import { Skeleton } from '@/new/components/shadcn/skeleton';

export function InconsistenciesLoader() {
  return (
    <div className="mx-5 flex flex-col gap-5 overflow-auto">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="w-full px-4 pb-2">
          <div className="w-full pt-1">
            <div className="mb-4 flex items-end justify-between gap-4">
              <div className="flex items-center gap-2">
                <Skeleton className="mr-1 h-4 w-4 rounded" />
                <Skeleton className="h-6 w-40 rounded-full" />
                <Skeleton className="h-8 w-36 rounded-md" />
              </div>
              <div className="flex flex-wrap items-center justify-end gap-1.5">
                <Skeleton className="h-5 w-32 rounded-sm" />
                <Skeleton className="h-6 w-40 rounded-full" />
                <Skeleton className="h-6 w-24 rounded-full" />
                <Skeleton className="h-6 w-28 rounded-full" />
              </div>
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-4/5" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
